import { render } from "./CookiesUpDownArrow.vue?vue&type=template&id=f8cc25b0"
import script from "./CookiesUpDownArrow.vue?vue&type=script&lang=js"
export * from "./CookiesUpDownArrow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__